import React from "react";

interface SearchFilterLayoutProps {
  label: string;
  children: React.ReactNode;
}

const SearchFilterLayout = ({ label, children }: SearchFilterLayoutProps) => {
  return (
    <div className="flex flex-1 flex-col gap-2">
      <p className="text-gray-secondary text-[14px] font-semibold">{label}</p>
      {children}
    </div>
  );
};

export default SearchFilterLayout;
